"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IRecord = exports.IMap = exports.ISet = exports.IList = exports.Iis = void 0;
var immutable_1 = require("immutable");
var Iis = function (a, b) { return (0, immutable_1.is)(a, b); };
exports.Iis = Iis;
exports.IList = immutable_1.List;
exports.ISet = immutable_1.Set;
exports.IMap = immutable_1.Map;
var IRecord = function (defaultValue) {
    var rf = (0, immutable_1.Record)(defaultValue);
    return function (value) { return rf(value); };
};
exports.IRecord = IRecord;
